import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  payloadCurrentPower: "",
};

const payloadCurrentPowerSlice = createSlice({
  name: "payloadCurrentPower",
  initialState,
  reducers: {
    setPayloadCurrentPower(state, action) {
      state.payloadCurrentPower = action.payload;
    },
  },
});

export const { setPayloadCurrentPower } = payloadCurrentPowerSlice.actions;
export default payloadCurrentPowerSlice.reducer;
